<template>
  <div class="text-center">
    <v-dialog scrollable v-model="dialog" ref="dlgInfo" width="650">
      <template v-slot:activator="{}"></template>
      <v-card class="pa-5">
        <v-card-title class="blue--text pb-0">
          Data Aktivitas LMS
        </v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col cols="12" sm="12" md="6">
              <v-list dense class="py-0">
                <v-list-item class="px-0">
                  <v-list-item-content>
                    <v-list-item-title class=" grey--text">SIMPKB ID:</v-list-item-title>
                    <v-list-item-subtitle class="font-weight-bold black--text">{{ detailLMS.email }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
            <v-col cols="12" sm="12" md="6" v-if="detailLMS.m_status">
              <v-list dense class="py-0">
                <v-list-item class="px-0">
                  <v-list-item-content>
                    <v-list-item-title class=" grey--text">Status:</v-list-item-title>
                    <v-list-item-subtitle class="font-weight-bold black--text">{{ detailLMS.m_status.keterangan }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
            <v-col cols="12" sm="12" md="12" v-if="detailLMS.m_level">
              <v-list dense class="py-0">
                <v-list-item class="px-0">
                  <v-list-item-content>
                    <v-list-item-title class=" grey--text">Level:</v-list-item-title>
                    <v-list-item-subtitle class="font-weight-bold black--text">{{ detailLMS.m_level.keterangan }}</v-list-item-subtitle>
                    <div class=" black--text pt-2">{{ detailLMS.m_level.deskripsi }}</div>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
          <p class="black--text pt-8">Berikut data aktivitas LMS yang telah Anda ikuti</p>
          <v-row dense>
            <v-col cols="12" sm="12" md="6" v-for="(item, index) in parsedOtherAtribut" :key="index">
              <v-list dense class="py-0">
                <v-list-item class="px-0">
                  <v-list-item-content>
                    <v-list-item-title class=" grey--text">{{ item.key }}:</v-list-item-title>
                    <div class="font-weight-bold black--text">
                      <!-- Periksa apakah item.value adalah URL yang valid -->
                      <template v-if="isValidUrl(item.value)">
                        <a :href="item.value" target="_blank">{{ item.value }}</a>
                      </template>
                      <template v-else>
                        {{ item.value }}
                      </template>
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black--text" text @click="closeGuide">Tutup</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "home-form-join-telegram",
  data() {
    return {
      dialog: false,
      filterData: [],
      detailLMS: {
        m_status: {
          keterangan: ""
        },
        m_level: {
          keterangan: ""
        }
      },
      defaultHeaders: [
        { text: "Key", value: "key" },
        { text: "Value", value: "value" }
      ]
    };
  },
  computed: {
    parsedOtherAtribut() {
      if (this.dialog) {
        let filteredData = [];

        try {
          // Parse JSON
          const parsedData = JSON.parse(this.detailLMS.other_atribut);

          // Filter berdasarkan kunci di filterData
          filteredData = Object.entries(parsedData)
            .filter(([key]) => this.filterData.includes(key))
            .map(([key, value]) => ({ key, value }));
        } catch (e) {
          console.error("Error parsing JSON:", e);
        }

        return filteredData;
      }
    }
  },
  methods: {
    open(val) {
      this.detailLMS = val.atribut;
      this.filterData = val.filterData;
      this.dialog = true;

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
        this.dialog = true;
      });
    },

    isValidUrl(value) {
      // Menggunakan regex untuk memeriksa apakah value adalah URL yang valid
      const urlPattern = new RegExp(
        "^https:\\/\\/" + // harus diawali dengan https://
        "(([a-zA-Z0-9$-_.+!*'(),;&]+)@)?" + // credentials (optional)
        "([a-zA-Z0-9.-]+(\\.[a-zA-Z]{2,4})+)" + // domain name
        "(:[0-9]{2,5})?" + // port (optional)
        "(\\/[-a-zA-Z0-9%_.~+]*)*" + // path (optional)
        "(\\?[;&a-zA-Z0-9%_.~+=-]*)?" + // query string (optional)
          "(#[-a-zA-Z0-9_]*)?$",
        "i"
      ); // fragment locator (optional)
      return !!urlPattern.test(value);
    },

    closeGuide() {
      this.dialog = false;
      this.resolve();
    }
  }
};
</script>

<style scoped>
/* Optional: Customize list styles for better readability */
.v-list-item-title {
  font-family: monospace; /* Using monospace for better JSON readability */
}
</style>
